import { render, staticRenderFns } from "./payeeInfo.vue?vue&type=template&id=56418887&scoped=true&"
import script from "./payeeInfo.vue?vue&type=script&lang=ts&"
export * from "./payeeInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56418887",
  null
  
)

export default component.exports